<template>
  <div>
    <b-modal id="permanent-employee" size="lg" title="Update Kontrak Karyawan" no-close-on-backdrop>
      <validation-observer ref="permanentEmployeeRef">
        <horizontal-form-group label="Status Karyawan">
          <validation-provider #default="{ errors }" name="Status Karyawan" rules="required">
            <v-select size="sm" v-model="formPayload.statusEmployee" :loading="loadingEmployee" :options="optionsEmployee" label="text">
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </horizontal-form-group>
        <horizontal-form-group label="Struktur Gaji">
          <validation-provider #default="{ errors }" name="Struktur Gaji" rules="required">
            <v-select size="sm" v-model="formPayload.structureSalary" :loading="loadingStruktur" :options="optionsStruktur" label="text">
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </horizontal-form-group>
        <horizontal-form-group label="Masa Kerja (Tahun)">
          <validation-provider #default="{ errors }" name="workingYears" rules="required">
            <b-form-input v-model="formPayload.workingYears"></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </horizontal-form-group>
      </validation-observer>
      <template #modal-footer="{}">
        <b-button class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="loading" @click="submitItem()">
          <b-spinner small variant="light" class="mr-1" v-if="loading" /> Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import { BModal, BButton,BFormSelect,BFormDatepicker,BSpinner,BFormInput } from "bootstrap-vue";
import { required } from "@validations";
import vSelect from "vue-select";
import { successNotification, errorNotification } from "@/auth/utils";
import { ParamSystemListService } from '../../services/param-system-list.service'
import { ComponentStructureSalaryServices } from '../../services/component-salary.service'
export default {
  name: "PopupPermanentEmployee",
  components: {
    BModal,
    BButton,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    required,
    BFormDatepicker,
    BSpinner,
    BFormInput
  },
  directives: {
    Ripple,
  },
  props: {
    loading: false
  },
  data() {
    return {
      optionsEmployee: [],
      loadingEmployee: false,
      loadingStruktur: false,
      optionsStruktur: [],
      formPayload: {
        statusEmployee: null,
        structureSalary: null,
        workingYears: ''
      },
    }
  },
  methods: {
    async GetStatusEmployee() {
      let req = {
        isDeleted: false,
        page: 1,
        paramSystemName: "EMPLOYEE_STATUS",
        size: 100,
        sortDirection: "ASC"
      };
      this.loadingEmployee = true;
      this.optionsEmployee = [];
      await ParamSystemListService.findAll(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items) => {
              this.optionsEmployee.push({
                text: items.paramListDesc,
                value: items
              });
            })
          } else {
            errorNotification(this, "Oops!", result.message);
          }
          this.loadingEmployee = false;
        })
        .catch((e) => {
          this.loadingEmployee = false;
          errorNotification(this, "Oops!", e.message);
        });
    },
    submitItem() {
      this.$refs.permanentEmployeeRef.validate()
        .then((result) => {
          if (result) {
            this.$emit('formPayload', this.formPayload);
          }
        });
    },
    ClosePopup() {
      this.$bvModal.hide('permanent-employee');
      this.formPayload   =  {
        statusEmployee: null,
        structureSalary: null,
        workingYears: ''
      };
    },
    async GetStruktureSalary() {
      this.loadingStruktur = true;
      let req = {
        page: 1,
        size: 100
      };
      this.optionsStruktur = [];
      await ComponentStructureSalaryServices.findAll(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items) => {
              this.optionsStruktur.push({
                text: items.name,
                value: items
              });
            });
          } else {
            errorNotification(this, "Oops!", result.message);
          }
          this.loadingStruktur = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loadingStruktur = false;
        })
    }
  },
  mounted() {
    this.GetStatusEmployee();
    this.GetStruktureSalary();
  }
}
</script>
<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
</style>

